import { createAction } from 'redux-actions'
import {
  GET_TAGS,
  GET_TAGS_FAILED,
  GET_TAGS_SUCCEEDED,
  CREATE_TAG,
  CREATE_TAG_FAILED,
  CREATE_TAG_SUCCEEDED,
  GET_TAG_MAPPINGS,
  GET_TAG_MAPPINGS_FAILED,
  GET_TAG_MAPPINGS_SUCCEEDED,
} from 'Redux/Types/TagTypes'

export const getTags = createAction(GET_TAGS)
export const getTagsFailed = createAction(GET_TAGS_FAILED)
export const getTagsSucceeded = createAction(GET_TAGS_SUCCEEDED)

export const createTag = createAction(CREATE_TAG)
export const createTagFailed = createAction(CREATE_TAG_FAILED)
export const createTagSucceeded = createAction(CREATE_TAG_SUCCEEDED)

export const getTagMappings = createAction(GET_TAG_MAPPINGS)
export const getTagMappingsFailed = createAction(GET_TAG_MAPPINGS_FAILED)
export const getTagMappingsSucceeded = createAction(GET_TAG_MAPPINGS_SUCCEEDED)
